
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import OrderedCheckBox from "@/components/utils/PopulateForms/components/OrderedCheckBox.vue";
import { nameInfoType, otherPartyInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType, childrenInfoSurveyInfoType } from '@/types/Application/CommonInformation/Pdf';
import { relocationOfChildInformationDataInfoType, relocationOfChildOtherPartyDataInfoType } from '@/types/Application/RelocationOfChild/PDF';
import { relocChildrenInfoDataInfoType, relocQuestionnaireSurveyDataInfoType, relocChildBestInterestSurveyDataInfoType } from '@/types/Application/RelocationOfChild';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import GreyBoxForm from "@/components/utils/PopulateForms/components/GreyBoxForm.vue";


@Component({
    components: {
        UnderlineForm,
        CheckBox,
        OrderedCheckBox,
        GreyBoxForm

    }
})

export default class Form16Layout extends Vue {

    @Prop({ required: true })
    result!: any;

    @applicationState.State
    public applicantName!: nameInfoType;
    dataReady = false;
    otherPartyInfo: relocationOfChildOtherPartyDataInfoType[] = [];
    additionalOtherParties: relocationOfChildOtherPartyDataInfoType[] = [];
    firstOtherParty = {} as relocationOfChildOtherPartyDataInfoType;
    yourInfo = {} as yourInformationInfoDataInfoType;
    relocInfo = {} as relocationOfChildInformationDataInfoType;

    existingFileNumber = '';
    filingLocationReason = '';
    childrenInfo = [{ fullName: '', dob: '', currentSituation: '' }];

    childrenFields = [
        { key: "fullName", label: "Child's full name", tdClass: "border-dark text-center align-middle", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:30%;" },
        { key: "dob", label: "Child's date of birth (dd/mmm/yyyy)", tdClass: "border-dark text-center align-middle", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:18%;" },
        { key: "currentSituation", label: "Child is currently living with", tdClass: "border-dark text-center align-middle", thClass: "border-dark text-center align-middle", thStyle: "font-size:8pt; width:16%;" },
    ]

    mounted() {
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;
    }

    public extractInfo() {

        this.otherPartyInfo = this.getOtherPartyInfo()
        this.firstOtherParty = this.otherPartyInfo[0];
        if (this.otherPartyInfo?.length > 1) {
            this.otherPartyInfo.splice(0, 1)
            this.additionalOtherParties = this.otherPartyInfo;
        }

        if (this.result.relocChildrenInfoSurvey?.length > 0) {
            this.childrenInfo = this.getChildrenInfo();
        }

        this.yourInfo = this.getYourInfo();
        this.relocInfo = this.getRelocInfo();
        this.existingFileNumber = getLocationInfo(this.result.filingLocationSurvey);

        if (this.result.filingLocationSurvey?.ExistingFamilyCase == 'y') {
            this.filingLocationReason = 'It is the court location where my existing case with the same party/parties is filed';
        } else if (this.result.filingLocationSurvey?.ExistingFamilyCase == 'n' && this.result.filingLocationSurvey?.filingLocationReason) {
            this.filingLocationReason = this.result.filingLocationSurvey.filingLocationReason;
        }
    }

    public getChildrenInfo() {

        const childrenInfo: childrenInfoSurveyInfoType[] = [];
        let childInfo = {} as childrenInfoSurveyInfoType;
        const childData: relocChildrenInfoDataInfoType[] = this.result.relocChildrenInfoSurvey;

        for (const child of childData) {
            childInfo = {} as childrenInfoSurveyInfoType;
            childInfo.fullName = Vue.filter('getFullName')(child.name);
            childInfo.dob = Vue.filter('beautify-date-mid')(child.dob);
            childInfo.currentSituation = child.currentLiving;
            childrenInfo.push(childInfo)
        }

        return childrenInfo;
    }

    public getYourInfo() {

        if (this.result?.yourInformationSurvey) {
            return getYourInformationResults(this.result?.yourInformationSurvey);
        }
        else
            return {} as yourInformationInfoDataInfoType
    }

    public getOtherPartyInfo() {

        let OpInformation: relocationOfChildOtherPartyDataInfoType[] = [];

        if (this.result.otherPartyCommonSurvey?.length > 0) {
            OpInformation = [];

            const otherPartyData: otherPartyInfoType[] = this.result.otherPartyCommonSurvey;

            for (const party of otherPartyData) {
                const otherParty = {} as relocationOfChildOtherPartyDataInfoType;

                if (party.knowDob == 'y' && party.dob)
                    otherParty.dob = party.dob

                if (party.name)
                    otherParty.name = party.name;

                if (party.address)
                    otherParty.address = party.address;

                if (party.contactInfo)
                    otherParty.contactInfo = party.contactInfo;

                if (party.lawyer)
                    otherParty.lawyer = party.lawyer

                OpInformation.push(otherParty)
            }
        }

        return OpInformation
    }

    public getRelocInfo() {

        const relocInformation = {} as relocationOfChildInformationDataInfoType;

        if (this.result.relocQuestionnaireSurvey) {

            const relocationQuestionnaireData: relocQuestionnaireSurveyDataInfoType = this.result.relocQuestionnaireSurvey;

            relocInformation.existingOrder = (relocationQuestionnaireData.ExistingParentingArrangements == 'y');
            relocInformation.existingOrderDate = (relocationQuestionnaireData.ExistingParentingArrangements == 'y' &&
                relocationQuestionnaireData.orderDate) ? relocationQuestionnaireData.orderDate : ']';
            relocInformation.receivedNotice = (relocationQuestionnaireData.receiveNotice == 'y');
            relocInformation.noticeDate = (relocationQuestionnaireData.receiveNotice == 'y' &&
                relocationQuestionnaireData.noticeDate) ? relocationQuestionnaireData.noticeDate : '';
            relocInformation.foundOutDate = (relocationQuestionnaireData.receiveNotice == 'n' &&
                relocationQuestionnaireData.foundOutDate) ? relocationQuestionnaireData.foundOutDate : '';
            relocInformation.foundOutDescription = (relocationQuestionnaireData.receiveNotice == 'n' &&
                relocationQuestionnaireData.foundOutAboutRelocationDescription) ? relocationQuestionnaireData.foundOutAboutRelocationDescription : '';
            relocInformation.impactOnChild = (relocationQuestionnaireData.impactOnChild == 'y');
            relocInformation.presumedRelocationDate = (relocationQuestionnaireData.receiveNotice == 'n' &&
                relocationQuestionnaireData.relocationDate) ? relocationQuestionnaireData.relocationDate : '';
            relocInformation.presumedLocation = (relocationQuestionnaireData.receiveNotice == 'n' &&
                relocationQuestionnaireData.childProposedLocation) ? relocationQuestionnaireData.childProposedLocation : '';

        }

        if (this.result.relocChildBestInterestInfoSurvey) {

            const relocChildBestInterest: relocChildBestInterestSurveyDataInfoType = this.result.relocChildBestInterestInfoSurvey;
            relocInformation.childBestInterestAcknowledgement = relocChildBestInterest.childBestInterestAcknowledgement.includes('I understand');
            relocInformation.childBestInterestReason = relocChildBestInterest.childBestInterestDescription;
        }

        return relocInformation;
    }

}
